import { render, staticRenderFns } from "./GroupSelect.vue?vue&type=template&id=3890f9a8"
import script from "./GroupSelect.vue?vue&type=script&lang=js"
export * from "./GroupSelect.vue?vue&type=script&lang=js"
import style0 from "./GroupSelect.vue?vue&type=style&index=0&id=3890f9a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports